
import { defineComponent } from 'vue';
import { useHead } from '@unhead/vue';
import WelcomeCardsComponent from "@/components/Welcome-cards/WelcomeCardsComp.vue";
import TopWeekCardsComponent from "@/components/Cards-wrapper/TopWeekCardsComp.vue";
import UseHeadService from "@/services/UseHeadService";

export default defineComponent({
  name: "WelcomeView",
  components: {TopWeekCardsComponent, WelcomeCardsComponent},
  setup() {
    const title = 'ModBox: лучшие игровые дополнения - скачать моды для игр'

    UseHeadService.title = title
    UseHeadService.description = 'Здесь вы можете скачать лучшие моды на машины, карты/трассы для Assetto Corsa, BeamNG Drive и других популярных игр.'
    UseHeadService.ogurl = 'https://mod-box.ru/'

    useHead({
      title: title,
      meta: UseHeadService.getMetaInfo()
    });
  },
})
